import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { useClientTranslation } from "hooks/useClientTranslation";
import { usePageTracking } from "hooks/usePageTracking";

export const ExpiredSession = () => {
  usePageTracking({ name: "Error - view", properties: { type: "Expired link" } });
  const { t } = useClientTranslation();

  return (
    <PageLayout title={t("error.expired_link.header")}>
      <Text sizeVariant="md" mt={24} mx={24}>
        {t("error.expired_link.instruction")}
      </Text>
    </PageLayout>
  );
};
